import {
  setToken,
  getToken,
  isLoggedIn,
  subscribe,
  unsubscribe,
} from "./tokenProvider";
import axios from "../components/common/axios";
import { useState, useEffect } from "react";

export const login = (newTokens) => {
  setToken(newTokens);
};

export const logout = () => {
  setToken(null);
};

export const authFetch = async (methodName, apiUrl, body) => {
  const token = await getToken();
  var config = {
    method: methodName,
    url: apiUrl,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    data: body,
  };
  const servicesWithBearerToken = [
    "auth-service",
    "user-service",
    "wash-inventory-service",
    "account-service-new",
    "wash-type-service",
    "notification-service",
    "organisation-service",
  ];
  const serviceRequiresBearerToken = servicesWithBearerToken.some((service) =>
    apiUrl.includes(service),
  );
  if (serviceRequiresBearerToken) {
    config.headers["Authorization"] = "Bearer " + token;
  } else {
    config.headers["Authorization"] = token;
  }
  return await axios(config);
};

export const useAuth = () => {
  const [isLogged, setIsLogged] = useState(isLoggedIn());

  useEffect(() => {
    const listener = (newIsLogged) => {
      setIsLogged(newIsLogged);
    };

    subscribe(listener);
    return () => {
      unsubscribe(listener);
    };
  }, []);

  return isLogged;
};
